import {Component, OnInit} from '@angular/core';
import {Waiter} from "../../shared/models/waiter";
import {WaiterService} from "../../core/http/waiter.service";
import {Order} from "../../shared/models/Order";
import {OrderService} from "../../core/http/order.service";
import {OrderPosition} from "../../shared/models/OrderPosition";
import {MatDialog} from "@angular/material/dialog";
import {
  ReceivedOrdersDetailsPopupComponent
} from "./received-orders-details-popup/received-orders-details-popup.component";
import {AuthService} from "../../core/auth/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-received-orders-overview',
  templateUrl: './received-orders-overview.component.html',
  styleUrls: ['./received-orders-overview.component.scss']
})
export class ReceivedOrdersOverviewComponent implements OnInit {

  orders: Order[] = [];
  displayedColumns: string[] = ['tableNumber', 'orderNo', 'total', 'waiterName', 'created', 'details', 'printAgain'];

  constructor(private orderService: OrderService, private dialog: MatDialog, private authService: AuthService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    const waiterShiftGuid = this.authService.getWaiterShiftGuid();
    if (waiterShiftGuid) {
      this.orderService.getAllOrdersOfShift(waiterShiftGuid).subscribe({
        next: (response) => {
          this.orders = response;
        },
        error: (error) => {
          console.log(error);
        }
      });
    }
  }

  showOrderDetails(positions: OrderPosition[]): void {
    this.dialog.open(ReceivedOrdersDetailsPopupComponent, {
      data: { positions }, // Pass the positions data to the popup component
      width: '800px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      // console.log(result)
      if (result) {
        this.ngOnInit();
      }
    });
  }

  printOrderAgain(order: Order): void {
    order.reprint = true;
    this.orderService.sendTableOrder(order).subscribe(response => {
      console.log('send table order');
      this._snackBar.open('Bestellung an Drucker gesendet', 'Schließen', {duration: 3000});
    });
  }

}
